import { Routes } from '@thg-commerce/enterprise-core'

export const generateAddReviewFormUrlWithReturnTo = (
  sku: number,
  originUrl: string,
  isLoggedIn: boolean,
) => {
  const addReviewUrl = `${Routes.AddReview}?productId=${sku}`
  return isLoggedIn
    ? `${addReviewUrl}`
    : `${Routes.Login}?returnTo=${encodeURIComponent(
        `${originUrl}${addReviewUrl}`,
      )}`
}

export const getReviewFiltersFromUrl = (filters: string) => {
  if (!filters) {
    return {}
  }

  const [filterName, filterValue] = filters.split(':')

  if (filterName?.trim() !== 'scores' || !filterValue?.trim()) {
    return {}
  }

  const ratingScores = filterValue.split('|') || []
  return { [filterName]: ratingScores }
}
